import Stack, { StackProps } from '@mui/material/Stack';
import { FC, ReactNode } from 'react';

interface IProps extends StackProps {
  direction?: 'row' | 'column';
  spacing?: number;
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
  children: ReactNode;
}

export const StackLayout: FC<IProps> = ({
  children,
  direction = 'row',
  spacing = 2,
  alignItems = 'center',
  ...otherProps
}) => {
  return (
    <Stack
      direction={direction}
      alignItems={alignItems}
      spacing={spacing}
      {...otherProps}
    >
      {children}
    </Stack>
  );
};
